import { QuotePlanSchema } from '../../../server/map-quotes';

export const filterWithQuoteKey = (
	filteredQuotes: QuotePlanSchema[],
	searchKey: keyof QuotePlanSchema,
	quoteKey: number
) => filteredQuotes?.filter((q) => q[searchKey] == quoteKey);
